import { useState } from 'react'
import MedicalProviderList from './MedicalProviderList';
import { Field } from 'formik';
import { TextInput } from '../index';
import MedicalFileUploadBtn from './MedicalFileUploadBtn';
import { validationFilesFunc } from '../../utils/helper';


const MedicalProviderSec = ({providerType,heading,tempProviderType,setFieldValue,formikValues,selectedTiffIndex,handleChange,setFileErrorList,setShowReorderSec}) => {
    const [isDisablefield,setDisablefield] = useState(false); // if provider name is same then disable field

    const onAddProvideName = (currentValue)=>{
        const filteredValue =  formikValues.medicalFiles[selectedTiffIndex][providerType].medicalRecords.find(obj=>obj.providerName.trim().toLowerCase() === currentValue.trim().toLowerCase());
        if(filteredValue){
            setDisablefield(true)
        }else{
            setDisablefield(false)
        }
    }

    const addMedicalFiles = async(e) => {
       
        console.log('from here')
        let files = Array.from(e.currentTarget.files);
        const validFiles = await validationFilesFunc(files,setFileErrorList);
        const newEntry = {
            providerName: formikValues.medicalFiles[selectedTiffIndex][tempProviderType].providerName,
            source: validFiles,
        };
     
        // Clear file input and provider name for new entry
        setFieldValue(`medicalFiles[${selectedTiffIndex}].[${tempProviderType}].medicalRecords`, []);
        setFieldValue(`medicalFiles[${selectedTiffIndex}].[${tempProviderType}].providerName`, '');
        setFieldValue(`medicalFiles[${selectedTiffIndex}].[${providerType}].medicalRecords`, [...formikValues?.medicalFiles[selectedTiffIndex]?.[providerType].medicalRecords, newEntry]);
    }
 
    return (
        <>
            <div className="d-flex justify-content-between align-items-center w-100 me-3 mb-3">
                <h2>{heading}</h2>
            </div>
            <MedicalProviderList providerType={providerType} formikValues={formikValues} setFieldValue={setFieldValue} selectedTiffIndex={selectedTiffIndex} setShowReorderSec={setShowReorderSec} setFileErrorList={setFileErrorList}/>
            <div className="card-item file-input mb-4">
                <h4 className="card-title mb-4">Add Provider
                </h4>
                <div className="row">
                    <div className="col-md-12">
                        <div>
                            <div className="d-flex align-items-center gap-2">
                                <div className="flex-grow-1 show-item">
                                    <Field name={`medicalFiles[${selectedTiffIndex}].[${tempProviderType}].providerName`} onChange={(e) => {
                                        handleChange(e); // set value in field
                                        onAddProvideName(e.target.value)
                                    }} label="Medical Provider / Facility" component={TextInput} />
                                </div>
                                <div className="m-t-3 text-md-end ">
                                    <MedicalFileUploadBtn isDisabled={isDisablefield} isBorder={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Field
                    type="file"
                    accept="application/pdf"
                    id={`medicalFiles[${selectedTiffIndex}].[${tempProviderType}].medicalRecords`}
                    name={`medicalFiles[${selectedTiffIndex}].[${tempProviderType}].medicalRecords`}
                    multiple
                    disabled={isDisablefield}
                    onChange={addMedicalFiles}
                />
            </div>
        </>
    )
}

export default MedicalProviderSec